import { render } from "./dialog-details.vue?vue&type=template&id=c68d28d8&scoped=true"
import script from "./dialog-details.vue?vue&type=script&lang=js"
export * from "./dialog-details.vue?vue&type=script&lang=js"

import "./dialog-details.vue?vue&type=style&index=0&id=c68d28d8&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c68d28d8"]])

export default __exports__